const ProgressBar = ({ progress }: { progress: number }) => {
  return (
    <div className="w-full overflow-hidden rounded bg-ph-gray-dirty-white">
      <div className="h-[10px] rounded bg-ph-primary-violet" style={{ width: `${progress}%` }} />
    </div>
  );
};

export default ProgressBar;
